import React from 'react'
import styled from 'styled-components'

const Column = styled.div`
  flex-grow: 1;
  line-height: 2rem;
`

export const TriColumn: React.FC = ({ children }) => <Column>{children}</Column>
